/**
 * FAQ Accordion - Lightweight, vanilla JS
 * - Uses native <details>/<summary> for accessibility & zero-JS fallback
 * - Closes other items when one opens (single-open behavior)
 * - Handles Load More / Show Less
 */
(function () {
  'use strict';

  function initFaqAccordion(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    var items = root.querySelectorAll('[data-faq-item]');

    // Single-open behavior: close others when one opens
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  }

  function initLoadMore(button) {
    if (!button || button.dataset.faqInit === 'true') return;
    button.dataset.faqInit = 'true';

    var root = button.closest('.faq-section').querySelector('[data-faq-accordion]');
    if (!root) return;

    var textEl = button.querySelector('[data-faq-load-more-text]');
    var textMore = button.dataset.textMore || 'Load more';
    var textLess = button.dataset.textLess || 'Show less';
    var expanded = false;

    button.addEventListener('click', function () {
      var hiddenItems = root.querySelectorAll('[data-faq-item][hidden]');

      if (!expanded) {
        // Show all hidden items
        hiddenItems.forEach(function (item) {
          item.hidden = false;
        });
        expanded = true;
        if (textEl) textEl.textContent = textLess;
        button.setAttribute('aria-expanded', 'true');
      } else {
        // Hide items beyond visible_count again
        var allItems = root.querySelectorAll('[data-faq-item]');
        var visibleCount = parseInt(root.dataset.visibleCount, 10) || 5;
        allItems.forEach(function (item, index) {
          if (index >= visibleCount) {
            // Close it if open before hiding
            if (item.open) item.open = false;
            item.hidden = true;
          }
        });
        expanded = false;
        if (textEl) textEl.textContent = textMore;
        button.setAttribute('aria-expanded', 'false');

        // Scroll back to the section top smoothly
        var section = button.closest('.faq-section');
        if (section && section.scrollIntoView) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-faq-accordion]').forEach(initFaqAccordion);
    document.querySelectorAll('[data-faq-load-more]').forEach(initLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
